import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import EfLink from '../ef-link';
import './index.scss';

export interface EfShopIconsAIconProps {
    /**
     * 图标
     */
    icon: React.ReactNode;
    /**
     * 图标侧的文案
     */
    title: string;
}
export interface EfShopIconsAProps {
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * label(处于标题之上的叫label)
     */
    label?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 副标题
     */
    subTitle?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 价格(在外面组合起来再往里传)
     */
    priceLabel?: React.ReactNode;
    /**
     * 购买按钮-文案
     */
    buyText?: string;
    /**
     * 购买按钮-链接
     */
    buyLink?: string;
    /**
     * 购买的 dataLayer
     */
    gtm_buy_dataLayer?: any[];
    /**
     * 埋点-购买点的buy
     */
    gtm_buy_position?: string;
    /**
     * 更多按钮-文案
     */
    moreText?: string;
    /**
     * 更多按钮-链接
     */
    moreLink?: string;
    /**
     * 没有链接时,启用该值显示more按钮
     */
    showMoreLink?: boolean;
    /**
     * 点击时的回调
     */
    moreCallback?: () => void;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 图标群
     */
    icons?: EfShopIconsAIconProps[];
}

/**
 * 维护:谢保林
 *
 * 推荐卡片
 */
const EfShopIconsA: React.FC<EfShopIconsAProps> = ({
    pc,
    h5,
    label,
    title,
    subTitle,
    desc,
    icons,
    priceLabel,
    buyText,
    buyLink,
    gtm_buy_dataLayer,
    gtm_buy_position,
    showMoreLink,
    moreCallback,
    moreText,
    moreLink,
    className,
}) => {
    const prefixCls = `ef-shop-icons-a`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const hasIcon = icons?.length; //是否有图标
    const buy_dataLayer2 = gtm_buy_dataLayer || [
        {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: title,
            position: gtm_buy_position || 'Product Preview',
        },
    ];
    return (
        <div className={classes}>
            <div className={`${prefixCls}-img`}>
                <EfImg pc={pc} h5={h5} />
            </div>
            <div className={`${prefixCls}-msg`}>
                <div className={`${prefixCls}-msg-in`}>
                    {label && <div className={`${prefixCls}-label`}>{label}</div>}
                    {title && <div className={`${prefixCls}-title`}>{title}</div>}
                    {subTitle && <div className={`${prefixCls}-subTitle`}>{subTitle}</div>}
                    {desc && <div className={`${prefixCls}-desc`}>{desc}</div>}
                </div>
                {hasIcon && (
                    <div className={`${prefixCls}-icon-box`}>
                        {icons?.map((item: any, index: number) => {
                            return (
                                <div key={index} className={`${prefixCls}-icon-item`}>
                                    <div className={`${prefixCls}-icon-l`}>{item.icon}</div>
                                    <div className={`${prefixCls}-icon-r`}>{item.title}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
                <div className={`${prefixCls}-footer`}>
                    {priceLabel && <div className={`${prefixCls}-price-box`}>{priceLabel}</div>}
                    <div className={`${prefixCls}-footer-in`}>
                        {(moreLink || showMoreLink) && moreText && (
                            <EfLink
                                href={moreLink}
                                className={`${prefixCls}-btn ${prefixCls}-btn-more`}
                                onClick={() => {
                                    moreCallback && moreCallback();
                                }}
                            >
                                {moreText}
                            </EfLink>
                        )}
                        {buyLink && buyText && (
                            <EfLink href={buyLink} className={`${prefixCls}-btn ${prefixCls}-btn-buy`} dataLayer={buy_dataLayer2}>
                                {buyText}
                            </EfLink>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EfShopIconsA;
